import React, { useState, useEffect } from "react";
import { EditView } from "../components/EditView";
import { SearchPanel } from "../components/SearchPanel";
import { AddView } from "../components/AddView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import ExcelHandler from "../components/ExcelHandler";

export function Products() {
  const [products, setProducts] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [addView, setAddView] = useState(false);
  const [showDeleted, setShowDeleted] = useState(false);

  const handleRowClick = (key) => {
    setSelectedRow(selectedRow === key ? null : key);
  };

  function handleClick() {
    setAddView(!addView);
  }
  function handleChange(e) {
    if (e.target.name === "showDeletedArticles") {
      setShowDeleted(e.target.checked);
    }
  }

  const fetchData = () => {
    setSelectedRow(null);
    //setLoading(true);

    let command = "Select";
    if (showDeleted) {
      command = "Select-Deleted";
    }

    fetch(
      `https://inventy.redata.se/inventdb/api_products.php?Command=${command}`,
    )
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setProducts(data);
        } else {
          console.error("Fetched data is not an array:", data);
          setProducts([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        setProducts([]); // Set products to an empty array on error
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [showDeleted]); // Dependencies array

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <SearchPanel setSearch={setSearch} placeholder={"Namn/Kategori..."} />
        {localStorage.getItem("Admin") == 1 && (
          <div>
            <button className="hoverButton" onClick={handleClick}>
              Lägg till produkt
            </button>
            <ExcelHandler refresh={fetchData} />
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "1vh",
          margin: "1vh",
        }}
      >
        <div>
          <label htmlFor="showDeletedArticles">Visa raderade artiklar </label>
          <input
            type="checkbox"
            id="showDeletedArticles"
            name="showDeletedArticles"
            value="1"
            checked={showDeleted}
            onChange={handleChange}
          />
        </div>
      </div>
      {addView && (
        <AddView setAddView={setAddView} refresh={fetchData} type="Product" />
      )}
      <div>
        <table>
          <thead>
            <tr>
              <th style={{ width: "auto", padding: "3vh" }}>Namn</th>
              <th>EAN</th>
              <th>Enhetspris</th>
              <th>Volym</th>
              <th>Typ</th>
              <th>Subklass</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product) => {
              if (
                search === "" ||
                product.Name.toLowerCase().includes(search.toLowerCase()) ||
                product.ItemGroup.toLowerCase().includes(
                  search.toLowerCase(),
                ) ||
                product.ItemSubGroup.toLowerCase().includes(
                  search.toLowerCase(),
                )
              ) {
                if (
                  selectedRow === product.ID &&
                  localStorage.getItem("Admin") === "1"
                ) {
                  return (
                    <EditView
                      object={product}
                      id={product.ID}
                      refresh={fetchData}
                      type="Product"
                      key={product.ID}
                    />
                  );
                } else {
                  return (
                    <tr
                      className={`hoverButton ${product.deleted == 1 ? "deletedRow" : ""}`}
                      onClick={() => handleRowClick(product.ID)}
                      key={product.ID}
                    >
                      <td>
                        {product.deleted == 1 && (
                          <FontAwesomeIcon icon={faTrash} />
                        )}
                        {" " + product.Name}
                      </td>
                      <td>{product.EAN1}</td>
                      <td>{product.Price + " SEK"}</td>
                      <td>{product.Volume + " L"}</td>
                      <td>{product.ItemGroup}</td>
                      <td>{product.ItemSubGroup}</td>
                    </tr>
                  );
                }
              }
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
